interface SessionProgressProps {
  done: number
  total: number
}

export function SessionProgress({ done, total }: SessionProgressProps) {
  const progress = total === 0 ? 0 : (done / total) * 100

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>Progress</span>
        <span>{done} / {total}</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-secondary">
        <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${progress}%` }} />
      </div>
    </div>
  )
}
